/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon20Solid = forwardRef('BookClosedIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4.333A3.333 3.333 0 0 1 6.333 1h8.792C16.16 1 17 1.84 17 2.875v10.25C17 14.161 16.16 15 15.125 15H6a1 1 0 1 0 0 2h10a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3V4.333ZM7.5 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-6Z" })));
});
